import { Grid, SearchBar, Space } from "antd-mobile";
import React, { CSSProperties } from "react";
import bg from "./assets/1.jpeg";
import t1 from "./assets/2.jpeg";
import t2 from "./assets/3.jpeg";
import t3 from "./assets/4.jpeg";
import t4 from "./assets/5.jpeg";

const TestScreen: React.FC = React.memo(() => {
  return (
    <div style={container}>
      <Grid columns={3} gap={8}>
        <Grid.Item>
          <div style={top}>海珠区园林绿化所树木电子档案管理系统</div>
        </Grid.Item>
      </Grid>
      <Grid columns={1} gap={24}>
        <Grid.Item>
          <div style={header}></div>
        </Grid.Item>
      </Grid>

      <div style={search}>
        <SearchBar
          placeholder="搜索树木信息"
          style={{ "--background": "#ffffff", "--height": "46px" }}
        />
      </div>
      <div style={main}>
        <Grid columns={4} gap={6}>
          <Grid.Item>
            <div>
              <img src={t1} style={{ width: "320px" }} />
              <div>中国植物名称 40,008 条， 异名45,197条</div>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div>
              <img src={t2} style={{ width: "320px" }} />
              <div>植物彩色图片8,103,211幅，线条图23,213幅 47,213份。</div>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div>
              <img src={t3} style={{ width: "320px" }} />
              <div>模式标本17,320份；腊叶标本1,992,345份</div>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div>
              <img src={t4} style={{ width: "320px" }} />
              <div>中国植物志 31,118 条；Flora of China 45,197条</div>
            </div>
          </Grid.Item>
        </Grid>
      </div>
      <div style={footer}>
        <Space>主办：广州市海珠区园林绿化所</Space>&nbsp;&nbsp;&nbsp;&nbsp;
        <Space>承办：广州市海珠区园林绿化所</Space>
      </div>
      <div style={footer2}>
        <Space>版权所有：广州市海珠区园林绿化所</Space>&nbsp;&nbsp;&nbsp;&nbsp;
        <Space>
          <a href="https://beian.miit.gov.cn/">粤ICP备xxxxx号-x</a>
        </Space>
      </div>
      <div style={footer2}>
        <Space>粤公网安备xxxx号</Space>&nbsp;&nbsp;&nbsp;&nbsp;
        <Space>访问量：78</Space>
      </div>
    </div>
  );
});

const container: CSSProperties = {
  height: "100vh",
  width: "100%",
};

const top: CSSProperties = {
  width: "100%",
  height: 60,
  alignItems: "center",
  lineHeight: "60px",
  paddingLeft: "64px",
  fontSize: 24,
  fontWeight: "bold",
  color: "rgb(144, 224, 85)",
};

const header: CSSProperties = {
  display: "flex",
  height: "40vh",
  width: "100%",

  backgroundImage: "url(" + bg + ")",
  backgroundRepeat: "repeat-x",
  justifyContent: "center",
};

const search: CSSProperties = {
  position: "absolute",
  top: "141px",
  left: "600px",
  width: "30%",
  height: "42px",
};

const main: CSSProperties = {
  width: "100%",
  height: "340px",
  marginTop: "30px",
  textAlign: "center",
  fontSize: 14,
};

const footer: CSSProperties = {
  width: "100%",
  minHeight: "40px",
  backgroundColor: "#eaeaea",
  fontSize: "14px",
  textAlign: "center",
  paddingTop: "10px",
};

const footer2: CSSProperties = {
  width: "100%",
  minHeight: "40px",
  backgroundColor: "#eaeaea",
  fontSize: "14px",
  textAlign: "center",
};

export default TestScreen;
